<script lang="ts">
    import { ServiceTokens } from '$src/domain/ServiceTokens';
    import type { IUserService } from '$src/domain/users/IUserService';
    import type { GroupStoreInfo, UserGroupStoreAccess } from '$src/domain/users/UserGroupStoreAccess';
    import type { UserSummary } from '$src/domain/users/UserSummary';
    import type { AuthContext } from '$src/infrastructure/accounts/AuthContext';
    import { isAuthenticated, user, authInitialized } from '$src/infrastructure/accounts/authStore';
    import { onDestroy, setContext } from 'svelte';
    import { writable, get } from 'svelte/store';
    import { container } from 'tsyringe';
    import { ContextTokens } from './ContextTokens';
    import { params, push } from 'svelte-spa-router';

    const authContext : AuthContext  = {
        isAuthenticated: isAuthenticated,
        user: user,
        authInitialized: authInitialized,
        me: writable<UserSummary | null>(null),
        activeGroupStore: writable<GroupStoreInfo | undefined>(undefined),
        groupStoresAccess: writable<UserGroupStoreAccess | null>(null)
    };
    
    setContext(ContextTokens.Auth, authContext);

    let unsubscribeUser;
    let unsubscribeParams;

    unsubscribeParams = params.subscribe(routeParams => {
      challengeGroupStoreAccess();
    });

    unsubscribeUser = user.subscribe(async account => {
        if (account) {
          const userService : IUserService = container.resolve(ServiceTokens.UserService);
          try {
            var myInformations = await userService.getMe();
          
            authContext.me.set(myInformations);
            authContext.activeGroupStore.set(myInformations.activeGroupStore);

            var myGroupStores = await userService.getMyGroupStores();
            authContext.groupStoresAccess.set(myGroupStores);

            challengeGroupStoreAccess();
          } catch(error) {

          }
        }
    });

    function challengeGroupStoreAccess() {
      let routeParams = get(params);
      let gsAccess = get(authContext.groupStoresAccess);
      let gsActive = get(authContext.activeGroupStore);

      if( gsAccess && routeParams ) {

        let routeGroupStoreId = routeParams.gsId;
        if( routeGroupStoreId ) {
          //check groupStore access
          var routeGroupStore = gsAccess.groupStores.find(gs => gs.groupStoreId.toString() == routeGroupStoreId);
          if(routeGroupStore) {
            //set active groupStore
            if( gsActive && gsActive.groupStoreId.toString() != routeGroupStoreId )
            {
              authContext.activeGroupStore.set(routeGroupStore);
            }
          }
          else {
            if( gsActive === undefined ) {
              //wait for next challenge when REST answer to getMe will trigger
            }
            else {
              //redirect to forbidden page
              push('/forbidden?url=');
            }
          }
        }
        // else {
        //   //use default grouptstore

        // }
      }
    }

    onDestroy(() => {
        if (unsubscribeUser) unsubscribeUser();
    });

  </script>
  
  <slot />
  